import { DialogContent, FormLabel, Stack, styled, TableCell } from "@mui/material";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { SelectArrow } from "../Icons";
import { toPx } from "../MuiHelpers";
import { TriggerArrowDown } from "../TriggersWithArrows";

export const TransactionsTabContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(6),
    }),
);

export const TransactionsTabHowToPayBottomStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        pt: theme.spacing(5),
    }),
);

export const StackBetween = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(2),
        },
    }),
);

export const TransactionTriggerArrow = styled(TriggerArrowDown)(({ theme }) =>
    theme.unstable_sx({
        py: theme.spacing(4),
    }),
);

export const StackSplitted = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
        "& span:first-of-type": {
            width: "50%",
        },
    }),
);

export const StackWithGap = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(3),
    }),
);

export const VerticalStackWithGap = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(3),
        flexDirection: "column",
    }),
);

export const SelectArrowOrange = styled(SelectArrow)(({ theme }) =>
    theme.unstable_sx({
        transform: "rotate(270deg)",
        color: theme.palette.primary.main,
        mx: theme.spacing(3),
    }),
);

export const WrappedTableCell = styled(
    TableCell,
    styledOmitPropsOptions,
)<{ $size?: number }>(({ theme, $size }) =>
    theme.unstable_sx({
        whiteSpace: "wrap",
        inlineSize: $size ? toPx($size) : "auto",
        textAlign: "right",
        pl: theme.spacing(5),
        pr: theme.spacing(3),
    }),
);

export const RightTableCell = styled(TableCell)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "right",
        px: theme.spacing(3),
        whiteSpace: "nowrap",
    }),
);

export const LeftTableCell = styled(TableCell)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "left",
        pr: theme.spacing(3),
        whiteSpace: "nowrap",
    }),
);

export const StackRowEndAligned = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: theme.spacing(1),
    }),
);

export const FilterFormLabel = styled(FormLabel)(({ theme }) =>
    theme.unstable_sx({
        fontSize: theme.typography.bodyTextM.fontSize,
        fontWeight: theme.typography.fontWeightBold,
        mb: theme.spacing(4),
    }),
);

export const FilterDialogContent = styled(DialogContent)(({ theme }) =>
    theme.unstable_sx({
        paddingTop: theme.spacing(3),
    }),
);
